import { Component, inject } from '@angular/core'
import { BricksCardComponent, BricksProgressSpinnerComponent } from '@enbw_bricks/ui'
import { LoadingSpinnerService } from './loading-spinner.service'
import { NgTemplateOutlet } from '@angular/common'

@Component({
  selector: 'app-loading-spinner',
  imports: [BricksProgressSpinnerComponent, BricksCardComponent, NgTemplateOutlet],
  templateUrl: './loading-spinner.component.html',
  styleUrl: './loading-spinner.component.scss',
})
export class LoadingSpinnerComponent {
  protected readonly service = inject(LoadingSpinnerService)
}
